<p-toast [style]="{marginTop: '80px'}"></p-toast>

<div class="grid" style="max-width:1580px;margin:0 auto;">
  <div class="col">
    <p-tabView [(activeIndex)]="tabIndex">
      <p-tabPanel header="Properties">
        <div class="p-4">
          <p class="mb-3">
            For detailed VRBO sync reports, see
            <a href="https://admin.kbmhawaii.com/data-report" target="_blank" rel="noopener noreferrer">Data Report</a>.
          </p>
          <p class="mb-3">
            For VRBO Logman endpoints and examples, see
            <a href="https://admin.kbmhawaii.com/vrbo-logman" target="_blank" rel="noopener noreferrer">VRBO Logman</a>.
          </p>
          <app-vrbo-property></app-vrbo-property>
        </div>
      </p-tabPanel>

      <p-tabPanel header="LodgingRate">
        <div class="p-4">
          <p class="mb-3">
            For detailed VRBO sync reports, see
            <a href="https://admin.kbmhawaii.com/data-report" target="_blank" rel="noopener noreferrer">Data Report</a>.
          </p>
          <p class="mb-3">
            For VRBO Logman endpoints and examples, see
            <a href="https://admin.kbmhawaii.com/vrbo-logman" target="_blank" rel="noopener noreferrer">VRBO Logman</a>.
          </p>
          <app-vrbo-reservation></app-vrbo-reservation>
          <div class="mt-4">
            <app-vrbo-lodging-rate></app-vrbo-lodging-rate>
          </div>
        </div>
      </p-tabPanel>

      <p-tabPanel header="Reservations">
        <div class="p-4">
          <p class="mb-3">
            For detailed VRBO sync reports, see
            <a href="https://admin.kbmhawaii.com/data-report" target="_blank" rel="noopener noreferrer">Data Report</a>.
          </p>
          <p class="mb-3">
            For VRBO Logman endpoints and examples, see
            <a href="https://admin.kbmhawaii.com/vrbo-logman" target="_blank" rel="noopener noreferrer">VRBO Logman</a>.
          </p>
          <app-vrbo-reservations></app-vrbo-reservations>
        </div>
      </p-tabPanel>

      <p-tabPanel header="Availability">
        <div class="p-4">
          <p class="mb-3">
            For detailed VRBO sync reports, see
            <a href="https://admin.kbmhawaii.com/data-report" target="_blank" rel="noopener noreferrer">Data Report</a>.
          </p>
          <p class="mb-3">
            For VRBO Logman endpoints and examples, see
            <a href="https://admin.kbmhawaii.com/vrbo-logman" target="_blank" rel="noopener noreferrer">VRBO Logman</a>.
          </p>
          <app-vrbo-availability></app-vrbo-availability>
          <div class="mt-4">
            <app-vrbo-unit-availability></app-vrbo-unit-availability>
          </div>
        </div>
      </p-tabPanel>

      <p-tabPanel header="Reviews">
        <div class="p-4">
          <app-vrbo-reviews></app-vrbo-reviews>
        </div>
      </p-tabPanel>
    </p-tabView>
  </div>
</div>


